import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  TextField,
  Checkbox,
  Grid,
  Box,
  FormControlLabel
} from "@material-ui/core";
import styled from "styled-components";
import Dialog from "../../../waybee-ui/Dialog";
import DialogTitle from "../../../waybee-ui/Dialog/DialogTitle";
import DialogContent from "../../../waybee-ui/Dialog/DialogContent";
import DialogActions from "../../../waybee-ui/Dialog/DialogActions";
import Button from "../../../waybee-ui/Button";
import { Can } from "../../../acl/can";

const DialogContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

const TestDialog = ({
  open,
  onClose,
  onSave,
  onDelete,
  isEditing,
  evaluation
}) => {
  const [description, setDescription] = useState(
    isEditing && evaluation.SProvas?.DESCRICAO
      ? evaluation.SProvas.DESCRICAO
      : ""
  );
  const [numQuestions, setNumQuestions] = useState(
    isEditing && evaluation.SProvas?.NUMQUESTOES
      ? parseInt(evaluation.SProvas.NUMQUESTOES, 10)
      : null
  );
  const [availableStudents, setAvailableStudents] = useState(
    isEditing && evaluation.SProvas?.DISPONIVELALUNOS
      ? evaluation.SProvas.DISPONIVELALUNOS === "S"
      : false
  );

  const [exclusiveDiscipline, setExclusiveDiscipline] = useState(
    isEditing && evaluation.SProvas?.DISPTODASSUBTURMAS
      ? evaluation.SProvas.DISPTODASSUBTURMAS === "S"
      : false
  );

  const [enablePortalDelivery, setEnablePortalDelivery] = useState(
    isEditing && evaluation.SProvas?.PERMITEENTREGAWEB
      ? evaluation.SProvas.PERMITEENTREGAWEB === "S"
      : false
  );

  const [activityCode, setActivityCode] = useState(
    isEditing && evaluation.SProvasCompl?.ATVMOODLE
      ? parseInt(evaluation.SProvasCompl.ATVMOODLE, 10)
      : false
  );

  const onSubmit = () => {
    onSave({
      ...(isEditing ? evaluation.SProvas : {}),
      DESCRICAO: description,
      NUMQUESTOES: numQuestions,
      DISPONIVELALUNOS: availableStudents,
      DISPTODASSUBTURMAS: exclusiveDiscipline,
      PERMITEENTREGAWEB: enablePortalDelivery,
      ATVMOODLE: activityCode,
      CODETAPA: evaluation.SProvas?.CODETAPA && evaluation.SProvas.CODETAPA
    });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth closeButton>
      <div>
        <DialogTitle>
          {!isEditing ? "Nova Avaliação" : "Editar Avaliação"}
        </DialogTitle>

        <DialogContent>
          {!isEditing &&
            "Para adicionar uma nova avaliação, preencha os campos abaixo e clique em Adicionar."}
          <DialogContainer>
            <Box mt={3} width="100%">
              <Grid item xs={10}>
                <TextField
                  label="Descrição"
                  value={description}
                  onChange={e => {
                    setDescription(e.target.value);
                  }}
                  type="text"
                  fullWidth
                />
              </Grid>
              <Grid item xs={10}>
                <TextField
                  label="Peso Avaliação (Fund.1)"
                  value={numQuestions}
                  onChange={e => {
                    setNumQuestions(e.target.value);
                  }}
                  type="number"
                  fullWidth
                />
              </Grid>
              <Grid item xs={10}>
                <FormControlLabel
                  control={(
                    <Checkbox
                      checked={availableStudents}
                      onChange={e => {
                        setAvailableStudents(e.target.checked);
                      }}
                      color="primary"
                    />
                  )}
                  label="Ativar"
                />
              </Grid>
              <Grid item xs={10}>
                <FormControlLabel
                  control={(
                    <Checkbox
                      checked={exclusiveDiscipline}
                      onChange={e => {
                        setExclusiveDiscipline(e.target.checked);
                      }}
                      color="primary"
                    />
                  )}
                  label="Avaliação Exclusiva para esta Turma/Disciplina"
                />
              </Grid>
              <Grid item xs={10}>
                <FormControlLabel
                  control={(
                    <Checkbox
                      checked={enablePortalDelivery}
                      onChange={e => {
                        setEnablePortalDelivery(e.target.checked);
                      }}
                      color="primary"
                    />
                  )}
                  label="Permitir entregas pelo portal"
                />
              </Grid>
              {/* <Grid container spacing={2}> */}
              {/*  <Grid item xs={6}> */}
              {/*    <FormControl fullWidth> */}
              {/*      <InputLabel>Tema da Avaliação</InputLabel> */}
              {/*      <Select */}
              {/*        {...register("type")} */}
              {/*        // value={age} */}
              {/*        // onChange={handleChange} */}
              {/*        label="Tema da Avaliação" */}
              {/*      > */}
              {/*        {testTypes.map(type => ( */}
              {/*          <MenuItem value={type}>{type.name}</MenuItem> */}
              {/*        ))} */}
              {/*      </Select> */}
              {/*    </FormControl> */}
              {/*  </Grid> */}
              {/*  <Grid item xs={6}> */}
              {/*    <TextField */}
              {/*      label="Valor" */}
              {/*      {...register("value")} */}
              {/*      type="number" */}
              {/*      fullWidth */}
              {/*    /> */}
              {/*  </Grid> */}
              {/*  {watch("type")?.editable && ( */}
              {/*    <Grid item xs={12}> */}
              {/*      <TextField */}
              {/*        label="Descrição" */}
              {/*        multiline */}
              {/*        maxRows={2} */}
              {/*        fullWidth */}
              {/*        {...register("description")} */}
              {/*      /> */}
              {/*    </Grid> */}
              {/*  )} */}
              {/* </Grid> */}
            </Box>
            <Box mt={3} width="100%">
              {enablePortalDelivery && (
                <Grid item xs={10}>
                  <TextField
                    label="Código de atividade moodle"
                    value={activityCode}
                    onChange={e => {
                      setActivityCode(e.target.value);
                    }}
                    type="number"
                    fullWidth
                  />
                </Grid>
              )}
            </Box>
          </DialogContainer>
        </DialogContent>
      </div>

      {!isEditing ? (
        <DialogActions>
          <Button variant="contained" color="secondary" onClick={onClose}>
            Voltar
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={onSubmit}
            type="submit"
          >
            Adicionar
          </Button>
        </DialogActions>
      ) : (
        <DialogActions>
          <Button variant="contained" color="secondary" onClick={onSubmit}>
            Editar
          </Button>
          <Can I="use module" a="DELETE_TEST">
            <Button
              variant="contained"
              color="primary"
              onClick={onDelete}
              type="submit"
            >
              Excluir
            </Button>
          </Can>
        </DialogActions>
      )}
    </Dialog>
  );
};

TestDialog.defaultProps = {
  open: false,
  isEditing: false,
  onSave: () => {},
  onDelete: () => {},
  evaluation: {}
};

TestDialog.propTypes = {
  open: PropTypes.bool,
  isEditing: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func,
  onDelete: PropTypes.func,
  evaluation: PropTypes.objectOf()
};

export default TestDialog;
